import React from 'react';
import './styles/prediction.css';
import ModelList from './components/ModelList';
import PredictionPanel from './components/PredictionPanel';
import PredictionResult from './components/PredictionResult';
import usePredictionHook from './hooks/usePredictionHook';
import { useI18n } from '../../i18n';

/**
 * Prediction — try a model you have trained against an image you have not.
 *
 * Three columns: pick a trained version, give it images, read what it said.
 * Everything it shows comes from a real forward pass on the training API
 * (`POST /prediction/predict`). Until 2026-09-21 this page called a stub that
 * returned `random.random()` per class against a model registry nothing ever
 * wrote to — so the list was always empty and the page looked dead.
 */
const Prediction = () => {
  const { t } = useI18n();
  const {
    catalogue,
    catalogueLoading,
    catalogueError,
    grouped,
    search,
    selected,
    selectedVersionId,
    conf,
    images,
    activeImage,
    activeDetections,
    rejected,
    running,
    canRun,
    progress,
    highlightedDetection,
    handlers,
  } = usePredictionHook();

  return (
    <div className="container-fluid lf-predict lf-fill-viewport">
      <div className="lf-predict__header">
        <h1 className="lf-predict__title">{t('prediction.title')}</h1>
        <p className="lf-predict__subtitle">{t('prediction.subtitle')}</p>
      </div>

      <div className="lf-predict__grid">
        <ModelList
          grouped={grouped}
          catalogue={catalogue}
          loading={catalogueLoading}
          error={catalogueError}
          search={search}
          selectedVersionId={selectedVersionId}
          onSearch={handlers.setSearch}
          onSelect={handlers.handleSelectVersion}
          onRefresh={handlers.loadModels}
        />

        <PredictionPanel
          selected={selected}
          images={images}
          activeImage={activeImage}
          activeDetections={activeDetections}
          rejected={rejected}
          running={running}
          canRun={canRun}
          conf={conf}
          progress={progress}
          highlighted={highlightedDetection}
          handlers={handlers}
        />

        <PredictionResult
          image={activeImage}
          detections={activeDetections}
          conf={conf}
          selected={selected}
          highlighted={highlightedDetection}
          onHighlight={handlers.setHighlightedDetection}
        />
      </div>
    </div>
  );
};

export default Prediction;
